import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import Loading from "../../components/Loading/Loading";
import { OperationalScopeServicesApi } from "../../service";

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './OperationalAreaManagement.module.css';
import { useHistory } from "react-router-dom";
import GenericModal from "../../UI/GenericModal";
import { isSuperuserValue } from "../../access/access";

const OperationalAreaManagement = () => {
  const [opAreasList, setOpAreasList] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  const history = useHistory();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    setIsLoading(true);
    let mounted = true;

    const operationalScopeServicesApi = new OperationalScopeServicesApi();
    operationalScopeServicesApi.getOperationalScopeMonitor( (error, data) => {
      if (mounted) {
        if (!error) {
          setOpAreasList(data);
          console.log("opScope list: ", data);
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }

      setIsLoading(false);
    });

    return () => {
      mounted = false;
    }
  }, []);

  const editOpAreaHandler = (scopeId) => {
    setIsLoading(true);
      history.push('/edit-operational-area?opAreaId='+scopeId);
  }

  const deleteOpAreaHandler = (opArea) => {
    setIsLoading(true);
    const operationalScopeServicesApi = new OperationalScopeServicesApi();
    operationalScopeServicesApi.deleteOperationalScopeById(opArea.id, (error, data) => {
      if (!error) {
        modalDataHandler("", `The operational area "${opArea.name}" was deleted`, 'notification', () => window.location.reload())  
      } else {
        modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, "Error! The operational area was not deleted!", 'error', () => setModalShow(false));
      }
    })
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  return <div className="pt-5 pb-2 d-flex justify-content-center align-items-center position-relative">
    <img
      src={nexiLogo}
      className={`${styles.logo}`}
      alt="nexi-group"
    />
    <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
    {!isLoading && <table className={`${styles.tableStyle}`}>
      <thead>
        <tr>
          <th>Operational Area</th>
          <th className={`${styles.buttonsCol} px-1`}>
            <SubmitButton class={styles.newElementButton} click={() => history.push('/new-operational-area')} align="center">New</SubmitButton>
          </th>
        </tr>
      </thead>
      <tbody>
        {opAreasList.map(el => {
          return (
            <tr key={el.id}>
              <td className="p-3">{el.name}</td>
              <td>
                <div className="d-flex">
                  <SubmitButton click={() => editOpAreaHandler(el.id)}>Edit</SubmitButton>
                    <SubmitButton click={() => modalDataHandler(
                      "Delete Operational Area",
                      `Delete operational area "${el.name}"?`,
                      'confirmation',
                      () => deleteOpAreaHandler(el) 
                    )}
                      disabled={!el.deletable}
                    >Delete</SubmitButton>
                </div>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>}
    {isLoading && <Loading />}
  </div>;
};

export default OperationalAreaManagement;
